import React from 'react';
import './navbar.css'
import { supabase } from '../../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {



 const [headericon, setheadericon]= useState([]);
      useEffect(() => {
      const getheadericon = async()=>{
          const res = await supabase.from('icons_navigation_mobile').select('*').order('id', { ascending: true });;;
    
      setheadericon(res.data);
      }
      getheadericon();
      }, []);




 const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const getheadericon = async () => {
            const res = await supabase
                .from('icons_navigation_mobile')
                .select('*')
                .order('id', { ascending: true });

            setheadericon(res.data);
        };

        getheadericon();
    }, []);

    const isActive = (path) => location.pathname === path;




    return ( 
        <nav className='navigationbar-container'>
            <nav className='row-navigation-bar'>
                <button 
                  onClick={() => navigate(headericon?.[2]?.url)}
                    className={`nav-item ${isActive('/home') ? 'active' : ''}`}>
                        <div className='nav-bg'></div>
                    <img src={headericon?.[2]?.img} alt={headericon?.[2]?.alt} ></img>
                    <h2 className='text-nav-bar'>{headericon?.[2]?.title}</h2>
                </button>


                <button 
                 onClick={() => navigate(headericon?.[3]?.url)}
                   className={`nav-item ${location.pathname.startsWith('/booking') ? 'active' : ''}`}>
                           <div className='nav-bg'></div>
                    <img src={headericon?.[3]?.img} alt={headericon?.[3]?.alt} ></img>
                    <h2 className='text-nav-bar'>{headericon?.[3]?.title}</h2>
                </button>


                <button 
                 onClick={() => navigate(headericon?.[4]?.url)}
                
                    className={`nav-item ${isActive('/map') ? 'active' : ''}`}>
                          <div className='nav-bg'></div>
                    <img src={headericon?.[4]?.img} alt={headericon?.[4]?.alt} ></img>
                    <h2 className='text-nav-bar'>{headericon?.[4]?.title}</h2>
                </button>

                <button 
                 
                    className={`nav-item ${isActive('/') ? 'active' : ''}`}>
                         <div className='nav-bg'></div>
                    <img src={headericon?.[5]?.img} alt={headericon?.[5]?.alt} ></img>
                    <h2 className='text-nav-bar'>{headericon?.[5]?.title}</h2>
                </button>

            </nav>
        </nav>
     );
}
 
export default Navbar;